<template>
	<div>
		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-md-6">
						<b-form @submit="onSubmitForm">
							<b-alert :show="showAlertError" variant="danger">
								<ul>
									<li v-for="(error, key) in errors" :key="key">{{ error }}</li>
								</ul>
							</b-alert>
							<b-form-group horizontal :class="{ 'has-error': $v.form.title.$error }" label="Название" label-for="title" class="is-required">
								<b-form-input id="title" maxlength="255" v-model.trim="form.title"></b-form-input>
							</b-form-group>

							<b-form-group horizontal :class="{ 'has-error': $v.form.short_title.$error }" label="Короткое название" label-for="short_title" class="is-required">
								<b-form-input id="short_title" maxlength="255" v-model.trim="form.short_title"></b-form-input>
								<b-form-text>Короткое название используется для документов.</b-form-text>
							</b-form-group>

							<b-form-group horizontal label="Описание" label-for="description">
								<b-form-textarea id="description" :rows="3" v-model.trim="form.description"></b-form-textarea>
							</b-form-group>

							<b-form-group horizontal :class="{ 'has-error': $v.form.product_type.$error }" label="Тип" label-for="product_type" class="is-required">
								<b-form-select id="product_type" v-model="form.product_type" class="col-sm-3">
									<option v-for="(product_type, key) in product_types" :key="key" :value="product_type">{{ product_type.name }}</option>
								</b-form-select>
							</b-form-group>
							<div v-if="form.product_type.parent_id === 1">
								<b-form-group horizontal label="Дата начала" label-for="start_at">
									<date-picker id="start_at" @dp-change="doSetSystemDate" v-model="form.start_at" :config="datePickerConfig"></date-picker>
								</b-form-group>

								<b-form-group horizontal label="Продолжительность" label-for="duration" >
									<b-form-select v-model="form.duration"  label="Продолжительность" label-for="duration" class="col-sm-3">
										<option v-for="(duration, key) in durationData" :key="key" :value="duration.value">{{ duration.text }}</option>
									</b-form-select>
									<b-form-text>Продолжительность дней.</b-form-text>
								</b-form-group>
							</div>
						</b-form>
					</div>
				</div>
			</div>
			<div class="card-footer">
				<div class="float-left">
					<b-button variant="primary" @click="onSubmitForm">Создать</b-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import eventAPI from '@/api/modules/event/event'
import Vue from 'vue'
import store from '@/store'
export default {
	components: {
		datePicker
	},
	data () {
		return {
			showAlertError: false,
			product_types: [],
			form: {
				title: '',
				short_title: '',
				description: '',
				start_at: '',
				product_type: []
			},
			systemDate: '',
			errors: {},
			datePickerConfig: {
				locale: 'ru',
				format: 'D MMMM, YYYY',
				useCurrent: true,
				date: ''
			},
			duration: '',
			durationData: [
				{value: 1, text: 1},
				{value: 2, text: 2},
				{value: 3, text: 3},
				{value: 4, text: 4},
				{value: 5, text: 5},
				{value: 6, text: 6},
				{value: 7, text: 7},
				{value: 8, text: 8},
				{value: 9, text: 9},
				{value: 10, text: 10}
			]
		}
	},
	validations: {
		form: {
			title: {
				required
			},
			short_title: {
				required
			},
			product_type: {
				required
			}
		}
	},
	created () {
		this.productType()
	},
	methods: {
		doSetSystemDate (e) {
			if (e.date !== false) this.systemDate = moment(e.date).format('YYYY-MM-DD')
		},
		productType () {
			Vue.http.get(store.state.apiURL + '/v1/event/types').then((response) => {
				this.product_types = response.body
			})
		},
		onSubmitForm (e) {
			e.preventDefault()
			this.$v.$touch()
			if (this.$v.$invalid) return false
			const data = {
				title: this.form.title,
				short_title: this.form.short_title,
				description: this.form.description,
				type_id: this.form.product_type.id,
				start_at: this.systemDate,
				duration: this.form.duration
			}
			eventAPI.create(data).then((response) => {
				this.clearForm()
				this.$notify({
					group: 'default',
					type: 'success',
					'title': 'Поздравляем!',
					text: 'Данные успешно созданы.'
				})
			}, (response) => {
				const errors = response.data.errors
				for (let key in errors) {
					this.$notify({
						group: 'default',
						type: 'danger',
						text: errors[key][0]
					})
				}
			})
		},
		clearForm () {
			Object.keys(this.form).forEach((key, index) => {
				this.form[key] = ''
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/event/indexTabs/create.vue